<template>
	<div :class="menuType">
		<sticky-menu-popup
			v-if="showStickyMenu"
			:top-menu-hover="isMenuHover"
			:fetched-data="fetchedData"
		/>
		<div
			id="__header__top_menu"
			class="top_menu"
			@mouseover="handleMenuMouseOver(true)"
			@mouseleave="handleMenuMouseOver(false)"
		>
			<div :class="dynamicContainer">
				<div
					class="menu_panel d-flex align-items-center justify-content-between"
				>
					<div>
						<nuxt-link
							v-if="
								fetchedData.id === 8662 ||
									fetchedData.id === 7792
							"
							:to="'/'"
							class="logo-khust"
						/>
						<nuxt-link
							v-else-if="fetchedData.id === 16725"
							:to="'/'"
							class="logo-atlanty"
						/>
						<nuxt-link
							v-else-if="fetchedData.id === 9162"
							:to="'/'"
							class="logo-yandex"
						/>
						<nuxt-link
							v-else-if="fetchedData.id === 18495"
							:to="'/'"
							class="logo-ProductCamp"
						/>
						<nuxt-link
							v-else-if="fetchedData.id === 4095"
							:to="'/'"
							class="logo-stories"
						/>

						<nuxt-link
							v-else-if="fetchedData.id === 19325"
							:to="'/'"
							class="logo-lean"
						/>

						<nuxt-link
							v-else-if="fetchedData.id === 21655"
							:to="'/'"
							class="logo-lean"
						/>

						<nuxt-link
							v-else-if="fetchedData.id === 70025"
							:to="'/'"
							class="logo-alfa"
						/>

						<nuxt-link
							v-else
							:to="$i18n.locale === 'ru' ? '/' : '/en/'"
							class="logo"
							:aria-label="$t('pages.home')"
							:title="`${fetchedData.meta_title}`"
						/>
					</div>
					<div
						v-if="!route && !hideSubmenu"
						class="d-none d-lg-block"
					>
						<div
							class="sub-menu d-flex justify-content-between align-items-center"
						>
							<template v-if="$i18n.locale === 'en'">
								<a href="/en/programmes/">
									{{ $t("programmes") }}
								</a>
								<a href="/en/faculty/">
									{{ $t("professors") }}
								</a>
								<a href="/en/research/">
									{{ $t("research") }}
								</a>
								<a href="/en/alumni/">Alumni</a>
							</template>
							<template v-else>
								<a href="/navigator/programmes/?typologies=1">
									{{ $t("programmes") }}
								</a>
								<a href="/faculty/">
									{{ $t("professors") }}
								</a>
								<a href="/research/">
									{{ $t("research") }}
								</a>
								<a href="/intrend/">inTrend</a>
								<a href="/alumni/">Alumni</a>
							</template>
						</div>
					</div>
					<div class="right-align">
						<div class="btn-panel d-none d-lg-flex">
							<nuxt-link
								v-if="$auth.loggedIn"
								:to="{
									name: 'user-profile',
									query: { item: 'MainInfo' },
									params: { redirectUrl: $route.fullPath },
								}"
								class="d-none d-lg-flex align-items-center"
							>
								<b-img-lazy
									v-if="$auth.user.avatar_url"
									:src="$auth.user.avatar_url"
									blank-color="lightgray"
									style="
										object-fit: cover;
										width: 30px !important;
										height: 30px !important;
									"
									class="mr-2 rounded-circle align-self-center"
								/>
								<div class="d-flex align-items-center">
									{{
										$auth.user.first_name ||
											$auth.user.email
									}}
									{{
										$auth.user.last_name
											? `${$auth.user.last_name.charAt(
												0
											)}.`
											: ""
									}}

									<!-- <template
										v-if="
											loyaltyProfile &&
												!isLoyaltyProfileFetching
										"
									>
										| {{ $points(roundedPointsSum) }}
										<div class="bonus_balance ml-1">
											Б
										</div>
									</template> -->
								</div>
								<!-- <div
										v-if="loyaltyProfile && !isLoyaltyProfileFetching"
										class="mt-1 text-right"
										style="font-size: 0.9rem"
									>
										{{ $t('bonusBalance') }}: {{ $points(roundedPointsSum) }}
									</div> -->
							</nuxt-link>
							<div v-else class="avatar">
								<a
									href="javascript:void(null);"
									:aria-label="$t('login')"
									@click="handleProfileClick"
								>
									<span
										class="icon icon-private d-flex align-self-center mr-4"
									/>
								</a>
							</div>

							<!-- <nuxt-link
								v-if="products.length"
								:to="{ name: 'cart' }"
								class="d-none d-lg-flex align-items-center"
							>
								<cart-svg class="icon d-flex align-self-center" />
								<div class="icon-cart">
									{{ products.length }}
								</div>
							</nuxt-link> -->

							<!-- <a
								v-if="$i18n.locale ==='ru'"
								href="javascript:void(null);"
								:aria-label="$t('impaired')"
								class="d-none d-lg-flex"
								@click="visuallyImpair"
							>
								<span class="icon icon-eye bvi-open" />
							</a> -->

							<a
								href="javascript:void(null);"
								:aria-label="$t('search')"
								class="d-none d-lg-flex"
								@click="$bvModal.show('search-modal')"
							>
								<span
									class="icon icon-search"
								/>
							</a>

							<a
								v-for="locale in availableLocales"
								:key="locale.code"
								role="button"
								class="lang_switch"
								@click="$i18n.setLocale(locale.code)"
							>
								{{ $i18n.locale }}
							</a>
						</div>
						<div>
							<div
								class="c-point icon-burger px-3"
								@click="$bvModal.show('modal-menu')"
							/>
						</div>
					</div>

					<!-- <nuxt-link :to="switchLocalePath('ru')">Italian</nuxt-link>
					<nuxt-link :to="switchLocalePath('en')">English</nuxt-link>-->
				</div>
			</div>
		</div>
		<SidebarMenu
			:disable-redirect="disableRedirect"
			:dynamic-container="dynamicContainer"
			:language-switch-link="languageSwitchLink"
			:loyalty-profile="loyaltyProfile"
			:rounded-points-sum="roundedPointsSum"
			:available-locales="availableLocales"
			:is-loyalty-profile-fetching="isLoyaltyProfileFetching"
		/>
	</div>
</template>

<script>
import _cloneDeep from 'lodash/cloneDeep';
import Intersect from 'vue-intersect';
import {
	mapActions, mapState, mapMutations, mapGetters,
} from 'vuex';
import CartSvg from '~/static/svg/cartSvg.vue';
import StickyMenuPopup from '~/components/StickyMenuPopup.vue';
import SidebarMenu from '~/components/layouts/_partials/SidebarMenu.vue';

const firstIdArr = [18435];

export default {
	name: 'TopMenuNew',
	components: {
		SidebarMenu, StickyMenuPopup, CartSvg, Intersect,
	},
	inject: {
		fetchedDataEventPage: { value: 'fetchedDataEventPage', default: null },
	},
	props: {
		fetchedData: { type: Object, default: () => ({}) },
		disableRedirect: { type: Boolean, default: false },
		menuType: { type: String, default: '' },
		hideSubmenu: { type: Boolean, default: false },
		fluid: { type: Boolean, default: false },
	},
	data() {
		return {
			isMenuVisible: false,
			loyaltyProfile: null,
			isMenuHover: false,
			isLoyaltyProfileFetching: false,
		};
	},
	computed: {
		...mapState({
			products: (state) => _cloneDeep(state.cart.products),
		}),
		...mapGetters({
			isAlumni: 'profile/isAlumni',
			isUserPointsChanged: 'loyalty/isUserPointsChanged',
		}),
		availableLocales() {
			return this.$i18n.locales.filter(
				(i) => i.code !== this.$i18n.locale,
			);
		},
		languageSwitchLink() {
			return this.fetchedData.alternative_language_version || null;
		},
		...mapState('visuallyImpair', {
			isVisuallyImpairLoaded: ({ isLoaded }) => isLoaded,
		}),
		route() {
			return (
				this.$route.path.startsWith('/user/')
				|| this.$route.path.startsWith('/cart/')
				|| this.$route.path.startsWith('/order/')
				|| this.$route.path.startsWith('/constructor/')
			);
		},
		roundedPointsSum() {
			return this.loyaltyProfile
				? Math.round(this.loyaltyProfile.points_sum)
				: 0;
		},
		showStickyMenu() {
			const isAlumniRoute = this.$route.path.split('/')[1] === 'alumni';
			// опрос завершен, пока скрыл - to do динамика нужна
			// return this.isAlumni && (this.$route.name === 'index' || isAlumniRoute);
		},
		dynamicContainer() {
			return this.fluid ? 'container-fluid' : 'container';
		},
	},
	watch: {
		isUserPointsChanged: {
			async handler() {
				if (!this.isUserPointsChanged) {
					return;
				}

				try {
					this.isLoyaltyProfileFetching = true;

					await this.getLoyaltyProfile();
					this.setIsUserPointsChanged(false);
				} finally {
					this.isLoyaltyProfileFetching = false;
				}
			},
		},
		'$auth.user': {
			handler(user) {
				if (user) {
					this.getLoyaltyProfile();
				}
			},
			immediate: true,
		},
		'fetchedData.alternative_language': {
			handler(alt) {
				if (this.fetchedData.alternative_language_version) {
					if (alt === 'rus' && this.$i18n.locale !== 'en') {
						this.$i18n.setLocale('en');
					} else if (!alt && this.$i18n.locale !== 'ru') {
						this.$i18n.setLocale(this.$i18n.locale);
					}
				}
			},
			immediate: true,
		},
		'$i18n.locale': {
			// eslint-disable-next-line complexity
			handler(lang, old) {
				if (
					this.fetchedDataEventPage
					&& ((this.fetchedDataEventPage.alternative_language
						=== 'rus'
						&& lang === 'ru')
						|| (this.fetchedDataEventPage.alternative_language
							=== 'eng'
							&& lang === 'en'))
				) {
					const altRoute = `${
						this.fetchedDataEventPage.event
							.alternative_language_version
					}${
						this.fetchedDataEventPage
							.alternative_language_version ?? ''
					}`;
					this.$router.push({ path: altRoute });
				} else if (!this.fetchedDataEventPage) {
					const alt = this.fetchedData.alternative_language;
					if (
						alt
						&& this.languageSwitchLink
						&& lang !== old
						&& !this.disableRedirect
					) {
						if (
							(alt === 'rus' && lang !== 'en')
							|| (alt === 'eng' && lang !== 'ru')
						) {
							this.$router.push({
								path: this.languageSwitchLink,
							});
						}
					}
				}
			},
		},
	},
	created() {
		const isLocal = this.$route?.name?.search('__en');
		if (isLocal > 0 && this.$i18n.locale === 'ru') {
			this.$i18n.setLocale('en');
		}
	},
	mounted() {
		if (this.$route.name === 'company-auth' && !this.$auth.loggedIn) {
			this.showRegistration();
			this.setClientState(2);
		}
		this.isMenuVisible = firstIdArr.includes(this.fetchedData.id);
		function changeBackgroundTopMenu() {
			const topMenu = document.getElementById('__header__top_menu');
			const mediaSlider = document.getElementById('media-slider-v2');
			if (mediaSlider) {
				if (window.scrollY >= mediaSlider.offsetHeight - 72) {
					topMenu.classList.add('top_menu_background');
				} else {
					topMenu.classList.remove('top_menu_background');
				}
			}
		}

		// window.addEventListener('scroll', changeBackgroundTopMenu, false);
	},
	methods: {
		...mapActions({
			showLoginPopup: 'authModal/showLogin',
			loadVisuallyImpair: 'visuallyImpair/load',
			showRegistration: 'authModal/showRegistration',
		}),
		...mapMutations({
			setClientState: 'authModal/setClientState',
			setIsUserPointsChanged: 'loyalty/setIsUserPointsChanged',
			setFieldOfProfile: 'profile/setFieldOfProfile',
		}),
		visuallyImpair(event) {
			const close = document.getElementById('bvi-panel-close');
			if (close) {
				close.click();
			} else if (!this.isVisuallyImpairLoaded) {
				this.loadVisuallyImpair(event.target);
			}
		},
		async getLoyaltyProfile() {
			const { data } = await this.$api.getLoyaltyProfile();

			if (data) {
				this.loyaltyProfile = data;

				this.setFieldOfProfile({
					slug: 'loyaltyProfile',
					value: data,
				});
			}
		},
		switchLanguage(language) {
			this.$i18n.setLocale(language);
			const altRoute = this.fetchedDataEventPage.event.alternative_language_version + this.fetchedDataEventPage.alternative_language_version;
			this.$router.push({ path: altRoute });
		},
		handleMenuMouseOver(value) {
			this.isMenuHover = value;
		},
		showSkolkovoIdPopup() {
			const params = `?return_url=${window.location.origin}${this.$route.fullPath}`;

			window.location.replace(`https://sk.skolkovo.ru/test_skolkovo_id_redirect${params}`);
		},
		handleProfileClick() {
			if (process.env.disabledProfile) {
				this.showSkolkovoIdPopup();
				return;
			}
			this.showLoginPopup();
		},
	},
};
</script>

<style lang="scss" scoped>
@import "~/assets/styles/components/layouts/top-menu-new-v2";

.bonus_balance {
	width: 1rem;
	height: 1rem;
	background-color: white;
	color: black;
	border-radius: 50%;
	font-size: 0.8rem;
	display: flex;
	justify-content: center;
	align-items: center;
	line-height: 0;
	font-weight: 700;
	padding-top: 1px;
	padding-left: 0.5px;
}
</style>
